import { render, staticRenderFns } from "./ReferralCampaignBanner.vue?vue&type=template&id=21f4cf5a&scoped=true"
import script from "./ReferralCampaignBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReferralCampaignBanner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ReferralCampaignBanner.vue?vue&type=style&index=0&id=21f4cf5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f4cf5a",
  null
  
)

export default component.exports